import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ConversacionCalidadService {
    urlConsultaTexto = 'https://barbering.iatich.de/openai/api/';

    constructor(
        private http: HttpClient
    ) { }

    getCalidad(conversacion) {
        const headers = new HttpHeaders();
        const body = { conversacion };

        return this.http.post(`${this.urlConsultaTexto}consulta-layout`, body, { headers });
    }
}
